module.exports = __webpack_public_path__ + "media/79.a6a41dd1.wav";